import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

const SYMBOLS: Record<string, string> = {
  BRL: 'R$',
  MXN: 'MX$',
  CLP: '$',     
  PEN: 'S/',    
  COP: '$',     
};

const LOCALES: Record<string, string> = {
  BRL: 'pt-BR',
  MXN: 'es-MX',
  CLP: 'es-CL',
  PEN: 'es-PE',
  COP: 'es-CO',
};

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  constructor(private auth: AuthService) {}

  get code(): string {
    return this.auth.getOriginCurrency();
  }

  get symbol(): string {
    return SYMBOLS[this.code] ?? this.code;
  }

  get locale(): string {
    return LOCALES[this.code] ?? 'pt-BR';
  }
}

